import React from "react";
import Paginator from "./Paginator.jsx";
import Flash from "./Flash.jsx";
import Currency from "./currency.js";
class Customers extends React.Component {
  constructor(props){
    super(props);
    this.RESULTS_PER_PAGE = 10;
    this.state = {
      customers: [],
      count: 0,
      page: 0,
      limit: this.RESULTS_PER_PAGE,
      flash_messages: [],
      flash_timestamp: ""
    };

    this.retrieve_customers = this.retrieve_customers.bind(this);

  }

  componentDidMount(){
    this.retrieve_customers(this.state.page, this.RESULTS_PER_PAGE);
  }

  retrieve_customers(page, limit){
    fetch(`/customers?offset=${page*this.RESULTS_PER_PAGE}&limit=${limit}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'/*,
        'x-csrf-token': this.csrf_token()*/
      }
    }).then((response) => {
      return response.json();
    }).then((json) => {
      if (!json.customers){
        return Flash.add_message(this, "Error encountered in retrieving Payments.", 'danger', 5);
      }
      this.setState({
        page: page,
        customers: json.customers,
        count: json.count
      });
    })
  }

  render () {
    return (
        <div className="psintegril-card">
          <Flash messages={this.state.flash_messages} timestamp={this.state.flash_timestamp} on_update={(flash_state) => this.setState(flash_state)} />
          <h1>Customers</h1>
          <div className="psintegril-table-container">
            <table className="psintegril-table">
              <tbody>
                <tr>
                  <th>
                    Application ID
                  </th>
                  <th>
                    Name
                  </th>
                  <th>
                    Email
                  </th>
                  <th>
                    Stripe ID
                  </th>
                  <th>
                    Status
                  </th>
                </tr>
                {this.state.customers.map(
                  (customer, index) => 
                  <tr key={index}>
                    <td>
                        {customer.id_internal}
                    </td>
                    <td>
                        <a href={`/s/customers/${customer.id}`}>{customer.name}</a>
                    </td>
                    <td>
                        {customer.email}
                    </td>
                    <td>
                        {customer.id_gateway}
                    </td>
                    <td>
                        {customer.status}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <Paginator on_page_change={(page) => {
            this.setState({page: page});
            this.retrieve_customers(page, this.RESULTS_PER_PAGE);
          }} results={this.state.count} per_page={this.RESULTS_PER_PAGE} page={this.state.page} />
        </div>
    );
  }
}

export default Customers;
